// eslint-disable-next-line no-unused-vars
exports.linkResolver = (doc) => {
  switch (doc.type) {
    case 'news':
      return `/news/${doc.uid}`;

    case 'events':
      return `/events/${doc.uid}`;

    case 'page':
      switch (doc.data?.type) {
        case 'partner-page':
          return `/partners/${doc.uid}`;

        case 'case':
          return `/cases/${doc.uid}`;

        default:
          if (doc.uid === 'index') {
            return '/';
          }

          return `/${doc.uid}`;
      }

    default:
      return `/${doc.uid}`;
  }
};
